import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { toggleSelectedYear, selectSimilarExRateMonths } from '../actions/index';

class DateSelector extends Component {
  constructor(props) {
    super(props);
    this.toggleSelectedYear = this.toggleSelectedYear.bind(this);
    this.renderYearSelectors = this.renderYearSelectors.bind(this);
  }
  toggleSelectedYear(year) {
    this.props.toggleSelectedYear(year);
  }
  renderYearSelectors() {
    const selectors = [];
    Object.keys(this.props.displayedYear).forEach(y => {
      selectors.push(
        <div
          className="year-selector"
          key={`year-${y}`}
        >
          <input
            type="checkbox"
            value={y}
            id={`year-${y}`}
            onChange={() => this.toggleSelectedYear(y)}
            checked={this.props.displayedYear[y]}
          />
          <label
            htmlFor={`year-${y}`}
            className={`btn -y${y}`}
          >{`${y}年度`}
          </label>
        </div>
      );
    });
    return selectors;
  }

  render() {
    return (
      <div className="year-selectors">
        {this.renderYearSelectors()}
      </div>
    );
  }
}

DateSelector.propTypes = {
  toggleSelectedYear: PropTypes.func,
  selectSimilarExRateMonths: PropTypes.func,
  displayedYear: PropTypes.object,
  selectedMonth: PropTypes.object,
};

const mapStateToProps = (state) => ({
  displayedYear: state.date.displayedYear,
});

export default connect(mapStateToProps,
  { toggleSelectedYear, selectSimilarExRateMonths })(DateSelector);



/** WEBPACK FOOTER **
 ** ./src/components/date_selector.js
 **/